import { render } from "./LbrxCheckbox.vue?vue&type=template&id=42fd5cb9&scoped=true"
import script from "./LbrxCheckbox.vue?vue&type=script&lang=js"
export * from "./LbrxCheckbox.vue?vue&type=script&lang=js"

import "./LbrxCheckbox.vue?vue&type=style&index=0&id=42fd5cb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fd5cb9"]])

export default __exports__